import type { ReactElement } from "react";

import type { LinkProps } from "react-router-dom";

import { styled } from "simplydo/react/styled";

import { RenderLabel } from "./Label";
import type { LabelStyleProps } from "./Label.types";

export type LabelLinkProps = LabelStyleProps &
  Omit<LinkProps, "color" | "children" | "className">;

const LabelLinkComponent = (props: LabelLinkProps): ReactElement => (
  <RenderLabel {...props} asLink />
);

export const LabelLink = styled(LabelLinkComponent)``;
